import { render, staticRenderFns } from "./ZoneGeofenceHistory.vue?vue&type=template&id=72135100&scoped=true&"
import script from "./ZoneGeofenceHistory.vue?vue&type=script&lang=js&"
export * from "./ZoneGeofenceHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72135100",
  null
  
)

export default component.exports